<div class="payments-scheduled">
    <mat-accordion multi class="mat-table">
      <section class="mat-header-row">
        <span class="mat-header-cell" *ngFor="let col of scheduledpaymentheader">{{col}}</span>
      </section>
      <span *ngIf="isLoadingPayments">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw mt-4"></i>
      </span>
      <mat-expansion-panel *ngFor="let payment of scheduledpayments" #exp>
        <mat-expansion-panel-header class="mat-row" matTooltip="CLICK FOR DETAILS" [matTooltipShowDelay]="2000">
          <span class="mat-cell">{{payment.nextScheduledDate | validDate}}</span>
          <span *ngIf="!isMobile" class="mat-cell">{{payment.scheduleNickName}}</span>
          <span class="mat-cell">{{payment.bankName}}</span>
          <span *ngIf="!isMobile" class="mat-cell">{{payment.accountNumberMasked}}</span>
          <span class="mat-cell">{{payment.amount | currency}}</span>
          <span *ngIf="!isMobile" class="mat-cell">{{payment.scheduleFrequencyText}}</span>
          <span *ngIf="!isMobile" class="mat-cell">{{payment.scheduleDayText}}</span>
          <span *ngIf="!isMobile" class="mat-cell">{{payment.scheduleStartDate | validDate}}</span>
  
          <!-- <span class="mat-cell">{{payment.lastPaymentDate | validDate}}</span> -->
          <div class="mat-cell">
            <span *ngIf="payment.canDelete" class="flex-ico-btns">
              <i (click)="editpayment(payment)" class="fa fa-pencil-square-o fa-md-blue" matTooltip="EDIT PAYMENT"
                aria-label="Edit Payment"
                matTooltipClass="tooltip-md"></i>
              <i (click)="deletepayment(payment); exp.expanded = !exp.expanded" class="fa fa-trash-o fa-md-blue"
                aria-label="Delete Payment"
                matTooltip="DELETE PAYMENT" matTooltipClass="tooltip-md"></i>
            </span>
            <span *ngIf="!payment.canDelete" class="flex-ico-btns">
              <i class="fa fa-clock-o fa-md-blue" matTooltip="PAYMENT PENDING" matTooltipClass="tooltip-md"></i>
            </span>
          </div>
        </mat-expansion-panel-header>
        <div class="payment-details-table-block">
          <table class="table table-bordered table-striped x-scrollable-table" tabindex="0">
            <thead class="payment-list-header">
              <tr>
                <th *ngFor="let col of paymentheader">{{col}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let par of payment.participantCollection">
                <td>{{par.firstName}} {{par.lastName}}</td>
                <td>{{par.secondaryId}}</td>
                <td>{{par.ssn | maskdata: 4}}</td>
                <td class="t-alignR">{{par.amount | currency}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>